import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from '../axios.jsx';
import ReactPaginate from 'react-paginate';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';

const URI = 'actualizacion/';
const URI3 = 'sendmailSAT/'

const ViewActualizacion = () => {
  const { codigo } = useParams();
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [viewItem, setViewItem] = useState(null);
  const [editText, setEditText] = useState('');
  const [newAction, setNewAction] = useState('');
  const [loading, setLoading] = useState(false);
  const [gestor, setGestor] = useState('');
  const [usernivel, setUsernivel] = useState('');

  const blogsPerPage = 10;
  const pageCount = Math.ceil(items.length / blogsPerPage);

  useEffect(() => {
    fetchUpdates();

    const user = sessionStorage.getItem('username');
    const nivel = sessionStorage.getItem('usernivel');
    if (user) setGestor(user);
    if (nivel) setUsernivel(nivel);
  }, [codigo]);

  const fetchUpdates = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${URI}${codigo}`);
      const arr = Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
      setItems(arr);
    } catch (err) {
      console.error('❌ fetch error:', err);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  const formatLocalDate = isoString => {
    if (!isoString) return '';
    const d = new Date(isoString);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).toLocaleDateString();
  };

  const handleAdd = async () => {
  const text = newAction.trim();
  if (!text) {
    alert("Todos los campos son requeridos");
    return;
    }
    Swal.fire({
        title: 'Guardando información...',
        text: 'Por favor espera un momento',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

  try {
    // 1) Guardar la acción
    await axios.post(`${URI}`, {
      codigo_SAT: codigo,
      accion: text,
      Gestor_SAT: gestor
    });

    // 2) Solo si el post fue exitoso, entonces enviar el correo
    await axios.get(URI3, {
      params: {
        codigo: codigo,
        tipo: "ACTUALIZACION",
        gestor: gestor
      },
    });

    // 3) Si todo fue bien:
    
Swal.fire({
      icon: 'success',
      title: 'Guardado exitoso',
      text: 'La información se ha guardado correctamente.',
      timer: 2000,
      showConfirmButton: false,
    });
    setNewAction('');
    setShowAdd(false);
    fetchUpdates();

  } catch (error) {
    // ❌ En caso de error
    Swal.fire({
      icon: 'error',
      title: 'Error al guardar',
      text: 'Ocurrió un problema al guardar la información.',
    });
    console.error(error);
  } } 


  const handleView = item => {
    setViewItem(item);
    setShowView(true);
  };

  const handleEdit = item => {
    if (usernivel === '1') {
    setViewItem(item);
    setEditText(item.accion);
    setShowEdit(true);
    } else {
        Swal.fire({
          icon: 'warning',
          title: 'Acción no permitida',
          text: 'Esta acción solo está permitida para administradores.',
        });}
  };

  const submitEdit = async () => {
  const text = editText.trim();
  if (!text || !viewItem) return;

  // Confirmación antes de editar
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: 'Esta acción no se puede deshacer.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#aaa',
    confirmButtonText: 'Sí, actualizar',
  });

  if (result.isConfirmed) {
    try {
      await axios.put(`${URI}${viewItem.id}`, { accion: text });
      setShowEdit(false);
      fetchUpdates();
      Swal.fire({
        icon: 'success',
        title: 'Actualizado',
        text: 'La actualización se realizó con éxito.',
      });
    } catch (err) {
      console.error('❌ Error editar:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo actualizar, inténtalo nuevamente.',
      });
    }
  }
};

  const handleDeleteBlog = async (item) => {
  // 1️⃣ Primero validar nivel de usuario
  if (usernivel !== '1') {
    return Swal.fire({
      icon: 'warning',
      title: 'Acción no permitida',
      text: 'Solo administradores pueden eliminar.',
    });
  }

  // 2️⃣ Solo administradores llegan aquí: mostrar confirmación
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: 'Esta acción no se puede deshacer.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminarlo',
  });

  // 3️⃣ Si confirma, realizar eliminación y feedback
  if (result.isConfirmed) {
    try {
      await handleDelete(item);
      Swal.fire({
        icon: 'success',
        title: 'Eliminado',
        text: 'La actualización fue eliminada correctamente.',
      });
    } catch (err) {
      console.error('❌ Error eliminar:', err);
      Swal.fire({
        icon: 'error',
        title: 'No se pudo eliminar',
        text: 'Ocurrió un error, intenta nuevamente.',
      });
    }
  }
};

const handleDelete = async (item) => {
  await axios.delete(`${URI}${item.id}`);
  fetchUpdates(); // REFRESCA datos tras eliminación :contentReference[oaicite:2]{index=2}
};

  const displayed = items
    .slice(pageNumber * blogsPerPage, (pageNumber + 1) * blogsPerPage)
    .map(u => (
      <tr key={u.id}>
        <td>{formatLocalDate(u.createdAt || u.createAt)}</td>
        <td>{u.Gestor_SAT}</td>
        <td>
          <Button variant="info" size="sm" className="act-action-btn" onClick={() => handleView(u)}><i className="fas fa-eye"></i></Button>
          <Button variant="warning" size="sm" className="act-action-btn" onClick={() => handleEdit(u)}><i className="fas fa-edit"></i></Button>
          <Button variant="danger" size="sm" className="act-action-btn" onClick={() => handleDeleteBlog(u)}><i className="fas fa-trash"></i></Button>
        </td>
      </tr>
    ));

  return (
    <div className="container mb-3 act-container">
      {/* Estilos propios: mismo lenguaje visual que ViewSARS/ViewERI */}
      <style>{`
        .act-container h3 {
          font-weight: 700;
          color: #1f3a5f;
        }

        .act-card {
          background: #fff;
          border-radius: 14px;
          box-shadow: 0 2px 14px rgba(0,0,0,0.08);
          padding: 1.25rem 1.25rem 0.5rem;
          margin-bottom: 1.75rem;
        }

        .act-card-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }

        .act-table-wrapper {
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e7ebf0;
        }

        .act-table {
          margin-bottom: 0;
        }

        .act-table thead th {
          background: linear-gradient(135deg, #4a2a7a, #7a4fc9);
          color: #fff;
          border: none;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          padding: 0.85rem 0.9rem;
          vertical-align: middle;
        }

        .act-table tbody td {
          padding: 0.75rem 0.9rem;
          vertical-align: middle;
          font-size: 0.92rem;
          border-color: #eef1f4;
        }

        .act-table tbody tr:hover {
          background-color: #f6f3fc;
          transition: background-color 0.15s ease-in-out;
        }

        .act-empty-row td {
          text-align: center;
          padding: 1.25rem;
          color: #8a94a6;
          font-style: italic;
        }

        .act-action-btn {
          border-radius: 8px !important;
          margin: 0 2px;
        }

        /* Modales */
        .modal-header.act-header {
          background: #4a2a7a;
          color: #fff;
        }
        .modal-header.act-header .btn-close {
          filter: invert(1) brightness(2);
        }

        .act-modal-body label {
          font-weight: 600;
          color: #334155;
          font-size: 0.88rem;
          margin-bottom: 4px;
          display: block;
        }

        .act-modal-body .form-control,
        .act-modal-body textarea {
          border-radius: 8px;
          border: 1px solid #dbe2ea;
        }
      `}</style>

      <h3>Actualizacion de {codigo}</h3>

      <div className="act-card">
        <div className="act-card-header">
          <h5 className="mb-0">Historial de actualizaciones</h5>
          <Button variant="primary" onClick={() => setShowAdd(true)}>
            <i className="fas fa-plus"></i> Agregar Actualizacion
          </Button>
        </div>

        {loading ? <p>Cargando...</p> : (
          <div className="act-table-wrapper">
            <table className="table table-striped act-table">
              <thead>
                <tr><th>Fecha</th><th>Gestor SAT</th><th>Acciones</th></tr>
              </thead>
              <tbody>
                {displayed.length ? displayed :
                  <tr className="act-empty-row"><td colSpan="3">No hay actualizaciones.</td></tr>}
              </tbody>
            </table>
          </div>
        )}

        {items.length > blogsPerPage && (
          <ReactPaginate
            previousLabel={'<'} nextLabel={'>'}
            pageCount={pageCount} onPageChange={({ selected }) => setPageNumber(selected)}
            containerClassName="pagination justify-content-center mt-3"
            pageClassName="page-item" pageLinkClassName="page-link"
            previousClassName="page-item" previousLinkClassName="page-link"
            nextClassName="page-item" nextLinkClassName="page-link"
            disabledClassName="page-item disabled" activeClassName="page-item active"
          />
        )}
      </div>

      <Button variant="secondary" onClick={() => navigate(-1)}>Volver</Button>

      {/* Agregar modal */}
      <Modal show={showAdd} onHide={() => setShowAdd(false)} backdrop="static" keyboard={false}>
        <Modal.Header className="act-header"><Modal.Title>Agregar actualización</Modal.Title></Modal.Header>
        <Modal.Body className="act-modal-body">
          <Form.Group>
            <Form.Label>Diligencie las acciones que se han realizado</Form.Label>
            <Form.Control as="textarea" rows={3}
              value={newAction}
              onChange={e => setNewAction(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAdd(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleAdd}>Guardar</Button>
        </Modal.Footer>
      </Modal>

      {/* Ver modal */}
      <Modal show={showView} onHide={() => setShowView(false)} backdrop="static" keyboard={false}>
        <Modal.Header className="act-header"><Modal.Title>Detalle de actualización</Modal.Title></Modal.Header>
        <Modal.Body className="act-modal-body">
          {viewItem && (
            <div>
              <p><strong>Código SAT:</strong> {viewItem.codigo_SAT}</p>
              <p><strong>Fecha:</strong> {formatLocalDate(viewItem.createdAt || viewItem.createAt)}</p>
              <p style={{ whiteSpace: 'pre-line' }}><strong>Acción:</strong> {viewItem.accion}</p>
              <p><strong>Gestor SAT:</strong> {viewItem.Gestor_SAT}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={() => setShowView(false)}>Cerrar</Button></Modal.Footer>
      </Modal>

      {/* Editar modal */}
      <Modal show={showEdit} onHide={() => setShowEdit(false)} backdrop="static" keyboard={false}>
        <Modal.Header className="act-header"><Modal.Title>Editar actualización</Modal.Title></Modal.Header>
        <Modal.Body className="act-modal-body">
          <Form.Group>
            <Form.Label>Diligencie las acciones que se han realizado</Form.Label>
            <Form.Control as="textarea" rows={3}
              value={editText}
              onChange={e => setEditText(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEdit(false)}>Cancelar</Button>
          <Button variant="primary" onClick={submitEdit}>Actualizar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewActualizacion;